import React, { Component } from 'react';
import { Avatar } from '@99designs/common/components/Avatar';

import FavoriteButton from 'components/FavoriteButton';
import { Designer } from 'apps/find-designers/propTypes';

import DesignerBranding from 'apps/find-designers/components/Listing/DesignerBranding';

class FeaturedSearchItem extends Component {
    // TODO: leaving array as we might want a carousel or something
    favoriteButton() {
        if (!this.props.designer.canFavorite) return null;
        return (
            <div className="featured-search-item-header__fav">
                <FavoriteButton
                    isFavorite={this.props.designer.isFavorite}
                    favoriteUrl={this.props.designer.urls.favoriteUrl}
                />
            </div>
        );
    }

    render() {
        const designer = this.props.designer;
        return (
            <div className="featured-search-item">
                <div className="featured-search-item__header">
                    <div className="featured-search-item-header">
                        <div className="featured-search-item-header__avatar">
                            <Avatar
                                user={{
                                    avatarUrl: designer.avatarSrc,
                                    profileUrl: designer.urls.profileUrl,
                                }}
                                variations={['medium']}
                                isOnline={false}
                            />
                        </div>
                        <div className="featured-search-item-header__branding">
                            <DesignerBranding
                                designer={this.props.designer}
                                profileUrl={designer.urls.profileUrl}
                                isContact={designer.isContact}
                                workRelationshipDescriptions={designer.workRelationshipDescriptions}
                            />
                        </div>
                        {this.favoriteButton()}
                    </div>
                </div>
                <a href={designer.urls.profileUrl} className="featured-search-item__gallery">
                    <picture
                        style={{
                            position: 'absolute',
                            display: 'block',
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <source
                            srcSet={designer.designs[0].imageSources.imageSrcLargeWebp}
                            type="image/webp"
                        />
                        <source
                            srcSet={designer.designs[0].imageSources.imageSrcLarge}
                            type="image/jpeg"
                            media="(min-width: 600px)"
                        />
                        <img
                            className="mediabox__media"
                            alt={designer.designs[0].title}
                            title={designer.designs[0].description}
                            src={designer.designs[0].imageSources.imageSrcLarge}
                            data-profile-design
                        />
                    </picture>
                </a>
            </div>
        );
    }
}

FeaturedSearchItem.propTypes = {
    designer: Designer.isRequired,
};

export default FeaturedSearchItem;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/FeaturedSearchItem.jsx